import { Component, Input } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PaymentBatchDescriptorsModalComponent } from './payment.batch.descriptors.modal.component';
import * as _ from 'lodash';

@Component({
    selector: 'payment-batch-descriptors-link',
    template: ` <a (click)="launchModal()" class="pointer">Site/Parcel Characteristics</a> `,
    imports: [],
})
export class PaymentBatchDescriptorsLinkComponent {
    constructor(private modalService: BsModalService) {}

    @Input() companyId: number;
    @Input() options: any;
    @Input() editMode: boolean;
    @Input() flatInUseDescriptors: Core.CompanyFeatureDescriptorModel[];

    launchModal() {
        const initialState = {
            companyId: this.companyId,
            paymentBatchDescriptors: _.cloneDeep(this.options.paymentBatchDescriptors),
            canEdit: this.editMode,
            flatInUseDescriptors: this.flatInUseDescriptors,
        };

        const modalRef = this.modalService.show(PaymentBatchDescriptorsModalComponent, {
            initialState,
            ignoreBackdropClick: true,
        });

        modalRef.content.onClose = (descriptors: Core.CompanyFeatureDescriptorModel[]) => {
            console.log(descriptors);
            this.options.paymentBatchDescriptors = descriptors;
        };
    }
}
